import {
  contact_email_validation,
  contact_phone_validation,
  contact_postcode_validation,
} from '../../constants/contact';

export function examinerValid(examiner) {
  if (
    ((examiner.forename !== '' && examiner.surname !== '') ||
      examiner.organisationName !== '') &&
    examiner.contactDetails?.address1 !== '' &&
    examiner.contactDetails?.address1?.length <= 40 &&
    examiner.contactDetails.cityName !== '' &&
    examiner.contactDetails.phoneNumber !== '' &&
    contact_phone_validation.test(
      examiner.contactDetails.phoneNumber.replace(/ /g, '')
    ) &&
    examiner.contactDetails.postcode !== '' &&
    contact_postcode_validation.test(
      examiner.contactDetails.postcode.replace(/ /g, '')
    ) &&
    (!examiner.contactDetails.emailAddress ||
      examiner.contactDetails.emailAddress === '' ||
      contact_email_validation.test(examiner.contactDetails.emailAddress))
  ) {
    return true;
  }
  return false;
}

export function surgeryFormValid(examiner) {
  if (
    ((examiner.forename !== '' && examiner.surname !== '') ||
      examiner.organisationName !== '') &&
    examiner.address1 !== '' &&
    examiner.address1?.length <= 40 &&
    examiner.cityName !== '' &&
    examiner.phoneNumber !== '' &&
    contact_phone_validation.test(examiner.phoneNumber.replace(/ /g, '')) &&
    examiner.postcode !== '' &&
    contact_postcode_validation.test(examiner.postcode.replace(/ /g, '')) &&
    (!examiner.emailAddress ||
      examiner.emailAddress === '' ||
      contact_email_validation.test(examiner.emailAddress))
  ) {
    return true;
  }
  return false;
}

function formatSurgeryErrorKey(key) {
  if (key === 'phoneNumber') {
    return 'number';
  }
  return key;
}

export function getSurgerySearchError(form) {
  return Object.keys(form)
    .filter((key) => form[key] !== '')
    .map((key) => `surgery ${formatSurgeryErrorKey(key)}`)
    .join(', ');
}

export default {};
